"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingType = exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["VALID"] = "valid";
    PaymentStatus["EXPIRING"] = "expiring";
    PaymentStatus["EXPIRED"] = "expired";
    PaymentStatus["INVALID"] = "invalid";
    PaymentStatus["PENDING_VERIFICATION"] = "pending_verification";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var FundingType;
(function (FundingType) {
    FundingType["CREDIT"] = "credit";
    FundingType["DEBIT"] = "debit";
    FundingType["PREPAID"] = "prepaid";
    FundingType["UNKNOWN"] = "not_known";
    FundingType["NOTAPPLICABLE"] = "not_applicable";
})(FundingType || (exports.FundingType = FundingType = {}));
//# sourceMappingURL=PaymentSource.js.map